import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, ReplaySubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiGridInfo, gridResponseModel, ResponseModel, SingleResponseModel, withCountResponseModel } from '../../models/base/base';

@Injectable({
  providedIn: 'root'
})
export abstract class BaseHttpService<T> {
  public baseUrl = environment.baseUrl + this.getResourceUrl();

  public channel = new BroadcastChannel('data-updates');

  private messageSubject = new ReplaySubject<any>();

  public messages$ = this.messageSubject.asObservable();



  constructor(public http: HttpClient) {
    this.channel.addEventListener('message', (event) => {
      this.messageSubject.next(event.data);
    });
  }

  /**
   * Broadcasts an update message to both same-tab and cross-tab listeners.
   * BroadcastChannel only delivers messages to OTHER tabs/windows, not the sender.
   * This method ensures same-tab AutoComplete components also receive the notification.
   */
  broadcastUpdate(message: string = 'new-item-added'): void {
    // For cross-tab communication
    this.channel.postMessage(message);
    // For same-tab communication (BroadcastChannel doesn't deliver to sender)
    this.messageSubject.next(message);
  }

  abstract getResourceUrl(): string;

  getAll(): Observable<SingleResponseModel<T[]>> {
    return this.http.get<SingleResponseModel<T[]>>(`${this.baseUrl}/GetAllData`);
  }

  getAllbyFilter(params = null): Observable<ResponseModel<T>> {
    let request = `${this.baseUrl}/Getalldatabyfilter`;
    if (params) return this.http.get<ResponseModel<T>>(request, { params: params });
    else return this.http.get<ResponseModel<T>>(request);
  }
  GetByEmpId(params = null): Observable<ResponseModel<T>> {
    let request = `${this.baseUrl}/GetByEmpId`;
    if (params)
      return this.http.get<ResponseModel<T>>(request, { params: params });
    else
      return this.http.get<ResponseModel<T>>(request);
  }

  // GetFilterDataFromUser(filterData, PageNumber, PageSize): Observable<ResponseModel<T>> {
  //   //custom filter
  //   let request = `${this.baseUrl}/GetFilterDataFromUser`;
  //   let params = { filterData: filterData, PageNumber: PageNumber, PageSize: PageSize };
  //   return this.http.get<ResponseModel<T>>(request, { params: params });
  // }

  get(id: any): Observable<SingleResponseModel<T>> {
    let params = { id: id };
    return this.http.get<SingleResponseModel<T>>(`${this.baseUrl}/GetById`, { params: params });
  }

  create(data: T): Observable<SingleResponseModel<T>> {
    return this.http.post<SingleResponseModel<T>>(`${this.baseUrl}/Create`, data);
  }

  createBulk(data: T[]): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/CreateBulkData`, data);
  }

  update(id: any, data: T): Observable<SingleResponseModel<T>> {
    return this.http.post<SingleResponseModel<T>>(`${this.baseUrl}/Update?id=` + id, data);
  }

  delete(id: any): Observable<any> {
    // let params = { Id: id };
    return this.http.post(`${this.baseUrl}/Delete?id=${id}`, {});
  }

  getbyParam(path: string, params: any): Observable<SingleResponseModel<T>> {
    // returns single record
    return this.http.get<SingleResponseModel<T>>(`${this.baseUrl}/${path}`, { params: params });
  }

  getAllbyParam(path: string, params: any): Observable<SingleResponseModel<T[]>> {
    // returns Array
    return this.http.get<SingleResponseModel<T[]>>(`${this.baseUrl}/${path}`, { params: params });
  }

  GetalldatabyfilterWithCount(pageindex, pagesize, extraparams = null): Observable<SingleResponseModel<ResponseModel<withCountResponseModel<T>>>> {
    let request = `${this.baseUrl}/GetalldatabyfilterWithCount`;
    let params = {};
    params['skipcount'] = (pageindex * pagesize);
    params['maxresultcount'] = pagesize;

    if (extraparams) params = { ...params, ...extraparams };
    return this.http.get<SingleResponseModel<ResponseModel<withCountResponseModel<T>>>>(request, { params: params });
  }

  gridList(menukey: string, pageparameter: string = null, fielddisplayon: number = 1, pageindex: number = 0, pagesize: number = 1, extraparams = null): Observable<SingleResponseModel<gridResponseModel<T>>> {
    let params = {}
    params['menukey'] = menukey;
    if(pageparameter) params['pageparameter'] = pageparameter;
    params['fielddisplayon'] = fielddisplayon;
    params['skipcount'] = (pageindex * pagesize);
    params['maxresultcount'] = pagesize;

    if (extraparams) params = { ...params, ...extraparams };
  //   return this.http
  // .get<SingleResponseModel<gridResponseModel<T>>>(`${this.baseUrl}/GridList`, { params })
  // .pipe(
  //   map(response => {
  //     // debugger
  //     if (response && response.result) {
  //       response.result.headers = response.result.headers.map(item => {
  //        return {
  //             ...item,
  //             fieldname: item.fieldname?.toLowerCase()   // ✨ خلي فيلد معين lowercase
  //           };
  //       });
  //     }
      
  //     return response;
  //   })
  // );


     return this.http.get<SingleResponseModel<gridResponseModel<T>>>(`${this.baseUrl}/GridList`, { params: params });
  }

  validateCodeExistance(code: number): Observable<SingleResponseModel<T>> {
    return this.http.get<SingleResponseModel<T>>(`${this.baseUrl}/ValidateCodeExist?code=${code}`);
  }

  // getByEmpId(empId: string): Observable<SingleResponseModel<T[]>> {
  //   return this.http.get<SingleResponseModel<T[]>>(`${this.baseUrl}/GetByEmpId?empId=${empId}`);
  // }
}
